import styled from 'styled-components';

interface IToolTipProps {
    top: string;
    left: string;
}
  
export const ToolTip = styled.div`
    padding: 7px 7px 7px 7px;
    background-color: #0E1318;
    border-radius: 5px;
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #FFFFFF;
    position: absolute;
    top: ${(props:IToolTipProps) => props.top};
    left: ${(props:IToolTipProps) => props.left};
`;
